export const CROPS_MODULE_NAME = "Crops";
